import React from 'react';
import { BASE_HISTORIC_CONFIG } from '../baseConfig';
import { HISTORIC_OPERATIONS_STATUS } from '../constants';
import OperationsStatusView from './OperationsStatusView';

const HistoricOperationsStatusView = (props) => (
  <OperationsStatusView
    trackerId="HISTORIC_CESSION_STATUS"
    headerTitle="Facturas históricas"
    headerDescription="Facturas operadas que ya fueron recaudadas"
    statusFilter={HISTORIC_OPERATIONS_STATUS}
    {...BASE_HISTORIC_CONFIG}
    {...props}
  />
);

export default HistoricOperationsStatusView;
